import { render, staticRenderFns } from "./ModalTrocaVenda.vue?vue&type=template&id=663212fc"
import script from "./ModalTrocaVenda.vue?vue&type=script&lang=js"
export * from "./ModalTrocaVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports